import script from "./CohortsSettingsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CohortsSettingsPage.vue?vue&type=script&setup=true&lang=js"

import "./CohortsSettingsPage.vue?vue&type=style&index=0&id=025e1696&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-025e1696"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QMarkupTable,QTr,QTh,QBtn,QTd,QIcon,QChip,QInnerLoading});
